module.exports = __webpack_public_path__ + "fonts/Alibaba-PuHuiTi-Medium.95620e10.otf";